import { C } from '../constants';
import LOGO from '../assets/logo';

// ─── CARGANDO ──────────────────────────────────────────────
function Cargando({ onReset }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: C.gray50, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <style>{`@keyframes slide{0%{transform:translateX(-100%)}100%{transform:translateX(350%)}}`}</style>
      <div style={{ textAlign: 'center', padding: '0 40px' }}>
        <img src={LOGO} alt="TandaClick" style={{ height: 80, width: 'auto', objectFit: 'contain' }} />
        <div style={{ fontSize: 20, fontWeight: 800, color: C.text, marginBottom: 28 }}>Cargando...</div>
        <div style={{ width: 240, height: 5, background: C.gray200, borderRadius: 99, margin: '0 auto', overflow: 'hidden' }}>
          <div style={{ width: '40%', height: '100%', background: C.primary, borderRadius: 99, animation: 'slide 1.2s ease-in-out infinite' }} />
        </div>
        <button onClick={onReset} style={{ marginTop: 40, background: 'none', border: 'none', color: C.textLt, fontSize: 12, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif", textDecoration: 'underline' }}>¿Algo salió mal? Volver al inicio</button>
      </div>
    </div>
  );
}


export { Cargando };
